import {
  ISubscription,
  SubscriptionStatus
} from "@wingspanhq/users/dist/lib/interfaces";

// Only `canceled` is a terminal state. Other non-active statuses
// (past_due, unpaid, incomplete) may still recover and must keep
// their current UI behavior. Deliberately NOT reusing
// subscriptionUtils.isSubscriptionCanceled — it also treats a
// scheduled (not yet effective) cancellation as canceled.
export const selectorIsSubscriptionEnded = (
  subscription?: ISubscription
): boolean =>
  !!subscription && subscription.status === SubscriptionStatus.canceled;
